/** Keep API errors serializable for Redux while preserving existing consumers. */
export function normalizeApiError(error) {
  const status = error.response?.status;
  const data = error.response?.data;
  const details = data && typeof data === 'object' && !Array.isArray(data) ? data : {};
  const message =
    (status < 500 && (details.error || details.message)) ||
    (status ? 'The server could not complete the request. Please try again later.' : 'Unable to reach the server. Check your connection.');

  return {
    ...details,
    message,
    error: message,
    status: status || null,
    code: error.code || null,
    requestId: error.response?.headers?.['x-request-id'] || null,
    response: status ? { status, data: { ...details, error: message } } : null
  };
}
